import cn from 'classnames';
import { HTMLAttributes } from 'react';
import { InDevelopingImage } from '@@/common/images';

import styles from './index.module.sass';

export function InDeveloping(props: IInDevelopingProps) {
  const { className, ...rest } = props;
  const rootClass = cn(className, styles.root);

  return (
    <div className={rootClass} {...rest}>
      <div className={styles.title}>Раздел находится в разработке</div>
      <img className={styles.image} src={InDevelopingImage} alt="В разработке" />
    </div>
  );
}

export interface IInDevelopingProps extends HTMLAttributes<HTMLDivElement> {}
